import React from 'react';
import ReactDOM from 'react-dom';
import {compose} from 'redux';

import AppStateHOC from '../lib/app-state-hoc.jsx';
import HashParserHOC from '../lib/hash-parser-hoc.jsx';
import HostedGUI from './hosted-gui.jsx';

/*
 * Render the GUI playground wired to our self-hosted backend.
 * {object} appTarget - the DOM element to render to
 */
export default appTarget => {
    const GUI = require('../containers/gui.jsx').default;
    GUI.setAppElement(appTarget);

    const playMatch = typeof window !== 'undefined' &&
        window.location.pathname.match(/^\/p\/(\d+)\/?$/);
    const sharedProjectId = playMatch ? playMatch[1] : null;

    const WrappedGui = compose(
        AppStateHOC,
        HashParserHOC
    )(HostedGUI);

    if (process.env.NODE_ENV === 'production' && typeof window === 'object' && !sharedProjectId) {
        // Fallback until ProjectSaverHOC mounts; then it warns only if projectChanged.
        window.onbeforeunload = () => true;
    }

    ReactDOM.render(
        <WrappedGui
            canEditTitle={!sharedProjectId}
            initialSharedProjectId={sharedProjectId || undefined}
            isPlayerOnly={!!sharedProjectId}
        />,
        appTarget
    );
};
